import billing01En from "./en/billing01.json";
import blog01En from "./en/blog01.json";
import booking01En from "./en/booking01.json";
import changelog01En from "./en/changelog01.json";
import chat01En from "./en/chat01.json";
import checkout01En from "./en/checkout01.json";
import commonEn from "./en/common.json";
import course01En from "./en/course01.json";
import dashboard01En from "./en/dashboard01.json";
import dashboard02En from "./en/dashboard02.json";
import events01En from "./en/events01.json";
import files01En from "./en/files01.json";
import fitness01En from "./en/fitness01.json";
import food01En from "./en/food01.json";
import form01En from "./en/form01.json";
import forum01En from "./en/forum01.json";
import health01En from "./en/health01.json";
import help01En from "./en/help01.json";
import inbox01En from "./en/inbox01.json";
import invoice01En from "./en/invoice01.json";
import landing01En from "./en/landing01.json";
import login01En from "./en/login01.json";
import login02En from "./en/login02.json";
import mobile01En from "./en/mobile01.json";
import mobile02En from "./en/mobile02.json";
import music01En from "./en/music01.json";
import onboarding01En from "./en/onboarding01.json";
import orders01En from "./en/orders01.json";
import product01En from "./en/product01.json";
import profile01En from "./en/profile01.json";
import project01En from "./en/project01.json";
import realEstate01En from "./en/realEstate01.json";
import settings01En from "./en/settings01.json";
import settings02En from "./en/settings02.json";
import signup01En from "./en/signup01.json";
import smartHome01En from "./en/smartHome01.json";
import status01En from "./en/status01.json";
import store01En from "./en/store01.json";
import travel01En from "./en/travel01.json";
import weather01En from "./en/weather01.json";
import billing01Tr from "./tr/billing01.json";
import blog01Tr from "./tr/blog01.json";
import booking01Tr from "./tr/booking01.json";
import changelog01Tr from "./tr/changelog01.json";
import chat01Tr from "./tr/chat01.json";
import checkout01Tr from "./tr/checkout01.json";
import commonTr from "./tr/common.json";
import course01Tr from "./tr/course01.json";
import dashboard01Tr from "./tr/dashboard01.json";
import dashboard02Tr from "./tr/dashboard02.json";
import events01Tr from "./tr/events01.json";
import files01Tr from "./tr/files01.json";
import fitness01Tr from "./tr/fitness01.json";
import food01Tr from "./tr/food01.json";
import form01Tr from "./tr/form01.json";
import forum01Tr from "./tr/forum01.json";
import health01Tr from "./tr/health01.json";
import help01Tr from "./tr/help01.json";
import inbox01Tr from "./tr/inbox01.json";
import invoice01Tr from "./tr/invoice01.json";
import landing01Tr from "./tr/landing01.json";
import login01Tr from "./tr/login01.json";
import login02Tr from "./tr/login02.json";
import mobile01Tr from "./tr/mobile01.json";
import mobile02Tr from "./tr/mobile02.json";
import music01Tr from "./tr/music01.json";
import onboarding01Tr from "./tr/onboarding01.json";
import orders01Tr from "./tr/orders01.json";
import product01Tr from "./tr/product01.json";
import profile01Tr from "./tr/profile01.json";
import project01Tr from "./tr/project01.json";
import realEstate01Tr from "./tr/realEstate01.json";
import settings01Tr from "./tr/settings01.json";
import settings02Tr from "./tr/settings02.json";
import signup01Tr from "./tr/signup01.json";
import smartHome01Tr from "./tr/smartHome01.json";
import status01Tr from "./tr/status01.json";
import store01Tr from "./tr/store01.json";
import travel01Tr from "./tr/travel01.json";
import weather01Tr from "./tr/weather01.json";

export const BLOCK_DICTIONARIES: Record<"tr" | "en", Record<string, string>> = {
    en: {
        ...commonEn,
        ...login01En,
        ...login02En,
        ...signup01En,
        ...dashboard01En,
        ...dashboard02En,
        ...orders01En,
        ...files01En,
        ...chat01En,
        ...inbox01En,
        ...project01En,
        ...onboarding01En,
        ...settings01En,
        ...settings02En,
        ...billing01En,
        ...booking01En,
        ...mobile01En,
        ...mobile02En,
        ...landing01En,
        ...blog01En,
        ...help01En,
        ...changelog01En,
        ...status01En,
        ...store01En,
        ...product01En,
        ...checkout01En,
        ...invoice01En,
        ...health01En,
        ...course01En,
        ...form01En,
        ...realEstate01En,
        ...events01En,
        ...profile01En,
        ...forum01En,
        ...smartHome01En,
        ...music01En,
        ...fitness01En,
        ...food01En,
        ...travel01En,
        ...weather01En
    },
    tr: {
        ...commonTr,
        ...login01Tr,
        ...login02Tr,
        ...signup01Tr,
        ...dashboard01Tr,
        ...dashboard02Tr,
        ...orders01Tr,
        ...files01Tr,
        ...chat01Tr,
        ...inbox01Tr,
        ...project01Tr,
        ...onboarding01Tr,
        ...settings01Tr,
        ...settings02Tr,
        ...billing01Tr,
        ...booking01Tr,
        ...mobile01Tr,
        ...mobile02Tr,
        ...landing01Tr,
        ...blog01Tr,
        ...help01Tr,
        ...changelog01Tr,
        ...status01Tr,
        ...store01Tr,
        ...product01Tr,
        ...checkout01Tr,
        ...invoice01Tr,
        ...health01Tr,
        ...course01Tr,
        ...form01Tr,
        ...realEstate01Tr,
        ...events01Tr,
        ...profile01Tr,
        ...forum01Tr,
        ...smartHome01Tr,
        ...music01Tr,
        ...fitness01Tr,
        ...food01Tr,
        ...travel01Tr,
        ...weather01Tr
    }
};
